import {tableSchema} from '@nozbe/watermelondb';

const userSchema = tableSchema({
  name: 'users',
  columns: [
    {
      name: 'user_id',
      type: 'string',
    },
    {
      name: 'name',
      type: 'string',
    },
    {
      name: 'cpf',
      type: 'string',
    },
    {
      name: 'email',
      type: 'string',
    },
    {
      name: 'phone',
      type: 'string',
    },
    {
      name: 'avatarUrl',
      type: 'string',
    },
    {
      name: 'token',
      type: 'string',
    },
    {
      name: 'codCompartilhar',
      type: 'string',
    },
    {
      name: 'phone_verified',
      type: 'boolean',
      isOptional: true,
    },
  ],
});

export {userSchema};
